import React, { createContext, useContext, useMemo } from "react";
import { readSessionClaims } from "./sessionContext";

function readSessionContext() {
  try {
    const claims = readSessionClaims();
    return { role: claims.role || "", tenant_domain: claims.tenant_domain || window.location.hostname };
  } catch (_error) {
    return { role: "", tenant_domain: window.location.hostname };
  }
}

const TenantContext = createContext({
  edgeContext: readSessionContext(),
});

export function TenantProvider({ children, value }) {
  const contextValue = useMemo(
    () => value || { edgeContext: readSessionContext() },
    [value]
  );
  return <TenantContext.Provider value={contextValue}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  return useContext(TenantContext);
}

export default TenantContext;
